import React, { useMemo, useRef, useEffect, useContext } from 'react';
import AnalyticsContext from './contexts/AnalyticsContext';
import EnvironmentVariablesContext
  from './contexts/EnvironmentVariablesContext';
import makeAnalyticsConfiguration from './utils/makeAnalyticsConfiguration';

export default function AnalyticsProvider({
  children,
}) {
  const pageviewSentForLocation = useRef(null);
  const environmentVariables = useContext(EnvironmentVariablesContext);

  const analyticsConfiguration = makeAnalyticsConfiguration(environmentVariables);

  const trackingCodes = analyticsConfiguration.trackers.filter(tracker => (
    tracker.trackingId !== undefined
  )).map(tracker => tracker.trackingId);

  useEffect(function() {
    const script = document.createElement('script');
    script.async = true;

    if (trackingCodes.length === 0) {
      console.warn("Empty Google Analytics tracking codes list.");
    }
    
    const firstTrackingCode = trackingCodes.shift();
    
    script.src = `https://www.googletagmanager.com/gtag/js?id=${firstTrackingCode}`;
    window.document.head.appendChild(script);
    
    const secondTrackingCode = trackingCodes.shift();
    
    if (secondTrackingCode !== undefined) {
      window.gtag('config', secondTrackingCode, {
        send_page_view: false,
      });
    }

    return function() {
      script.remove();
    }
  }, trackingCodes);
  
  const value = useMemo(() => ({
    pageviewSentForLocation,
  }), []);

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  )
}
